import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-800 dark:bg-slate-950 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-4">GenXDojo</h3>
          <p className="text-slate-300 dark:text-slate-400 mb-8">
            AI training designed specifically for Generation X professionals.
          </p>
          <div className="border-t border-slate-700 dark:border-slate-800 pt-8">
            <p className="text-slate-300 dark:text-slate-400">
              &copy; 2025 GenXDojo. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;